// @ts-nocheck
import React from 'react';

import Text from 'crehana-ui/Text';
import Dialog from 'crehana-ui/Dialog';
import PrimaryButton from 'crehana-ui/Buttons/PrimaryButton';
import { useTranslation } from '@crehana/i18n';

const EnrollmentDialog = ({ open, setOpen }) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onDismiss={() => {
        setOpen(false);
      }}
    >
      <div className="flex flex-col items-center justify-center py-56">
        <Text type="h3" as="h3" className="mb-16">
          {t('ENROLLMENT_DIALOG_TITLE')}
        </Text>
        <Text type="body3" as="p" className="mb-32 px-24 text-center">
          {t('ENROLLMENT_DIALOG_DESCRIPTION')}
        </Text>
        <PrimaryButton
          label={t('ENROLLMENT_DIALOG_CLOSE')}
          onClick={() => {
            setOpen(false);
          }}
        />
      </div>
    </Dialog>
  );
};

export default EnrollmentDialog;
